@if (!restrictions?.isFullAccountLock()) {
  <router-outlet></router-outlet>
} @else {
  <app-full-account-lock></app-full-account-lock>
}

@if (!loader.loaded) {
  <app-main-preloader></app-main-preloader>
}
